/**
 * Wearable Jewelry theme — variant sync for Wearable try-on app blocks.
 * Dispatches variant:change when the PDP selection changes so data-variant-id stays current.
 */
(function () {
  function syncWearableBlocks(variantId) {
    if (!variantId) return;
    document.querySelectorAll(".wearable-tryon-block").forEach(function (root) {
      root.setAttribute("data-variant-id", String(variantId));
      var gid =
        "gid://shopify/ProductVariant/" + String(variantId).replace(/\D/g, "");
      root.setAttribute("data-variant-gid", gid);
    });
  }

  document.addEventListener("variant:change", function (e) {
    var detail = e.detail || {};
    if (detail.variantId) syncWearableBlocks(detail.variantId);
  });

  /** Initial sync from product form hidden input if present. */
  document.addEventListener("DOMContentLoaded", function () {
    var input = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]',
    );
    if (input && input.value) syncWearableBlocks(input.value);
  });
})();
